import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import fuente from "./OpenSans-Light.ttf"
import {
  Document,
  Page,
  View,
  Text,
  Svg,
  Path,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import { fetchApi } from "../../../../tools";
import { useSelector } from "react-redux";

// const data = [1, 2, 3, 4, 5, 6, 7, 8, 9]; // segun la data recibida desde la api
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    marginTop:5,
    paddingBottom:50,
    stroke:0.2
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

Font.register({
  family: 'OpenSans-Light',
  fonts: [
    {
      src: fuente
    },
    { src: fuente, fontStyle: 'italic' },
    { src: fuente, fontStyle: 'italic', fontWeight: 700 },

  ]
})

const RevisionExistenciaPDF = ({ sede, data, sedeSeleccionada }) => {

  let dataOriginal = data;
  
  useEffect(() => {
    //  
    let hash = {}
    dataOriginal = dataOriginal.filter(o => hash[o.IdProducto] ? false: hash[o.IdProducto] = true);
    // setDatos(() =>dataOriginal)
  }, [])
  

  return (
    <Document>
      <Page style={styles.body} size="letter">
      <Text
          style={{
            position: "absolute",
            fontSize: 12,
            bottom: 10,
            top:20,
            left: 550,
            //right: 0,
            textAlign: "end",
            color: "grey",
          }}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        ></Text>
        <View style={{ width: "550", height: "55", marginBottom:"20", flexDirection: "row" }}>
          <Svg
            style={{ width: "500", marginLeft:"-10"}}
            fill="white"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="black"
            aria-hidden="true"
            className="h-11 w-11 mr-2 text-secundario"
          >
            <Path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12"
            ></Path>
          </Svg>
          <View
            style={{
              width: "5500",
              height: "55",
              marginLeft:"-50",
              flexDirection: "col",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*
          <Text
          style={{
            position: "absolute",
            fontSize: 12,
            bottom: 10,
            top:0,
            left: 500,
            //right: 0,
            textAlign: "end",
            color: "grey",
          }}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        ></Text>
          */}
            <Text style={{ fontSize: "12" }}>Revisión de existencia</Text>
            <Text style={{ fontSize: "12" }}>{`${sede || "bodega aún no configurada"}`}</Text>
          </View>
        </View>
        <View style={{ width: "550", height: "55", flexDirection: "row" }}>
          <View
            style={{
              width: "105",
              height: "55",
              border: "0.2",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: "12" }}>ID PRODUCTO</Text>
          </View>
          <View
            style={{
              width: "310",
              height: "55",
              border: "0.2",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            
            <Text style={{ fontSize: "12" }}>PRODUCTO</Text>
          </View>
          {/*
          <View
            style={{
              width: "80",
              height: "55",
              border: "1",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: "12" }}>EXISTENCIA</Text>
          </View>
            */}
          <View
            style={{
              width: "130",
              height: "55",
              border: "0.2",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: "12" }}>RECUENTO FÍSICO</Text>
          </View>
        </View>
        {dataOriginal.map((element) => (
          <View style={{ width: "550", height: "20", flexDirection: "row"}}>
            <View style={{ width: "105", height: "20", border: "0.2", alignItems:"center" }}><Text style={{ fontSize: "12", marginVertical:"auto" }}>{element.IdProducto}</Text></View>{/* -80 al agregar otra*/}
            <View style={{ width: "310", height: "20", border: "0.2" }}><Text style={{ fontSize: "12", fontFamily:"OpenSans-Light", marginLeft:"2px"}} >{element.Descripcion}</Text></View>
            {/*
            <View style={{ width: "80", height: "20", border: "1", alignItems:"center" }}><Text style={{ fontSize: "12" }}>{element.Existencia}</Text></View>
            */}
            <View style={{ width: "130", height: "20", border: "0.2" }}><Text style={{ fontSize: "12" }}></Text></View>
          </View>
        ))}
        <View>

        </View>
      </Page>
    </Document>
  );
};

export default RevisionExistenciaPDF;
